import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import classNames from '../../node_modules/classnames/index.js';
import styles from './TabNavigation.module.scss.js';
import { applyCommonProps } from '../utility/commonProps.js';

var _excluded = ["children", "className"];
/**
 * Tab Navigation allows for page-level navigation between sets of content, typically used at the top of the screen.
 *
 * {@link https://livingdesign.walmart.com/components/tab-navigation/ Guidelines}
 * {@link https://livingdesign.walmart.com/components/tab-navigation/react/ React documentation}
 *
 * ### Content
 *
 * Tab Navigation's accepts Tab Navigation Items through the `children` prop:
 *
 * ```tsx
 * <TabNavigation>
 *   <TabNavigationItem href="/1/">One</TabNavigationItem>
 *   <TabNavigationItem href="/2/">Two</TabNavigationItem>
 *   <TabNavigationItem href="/3/">Three</TabNavigationItem>
 * </TabNavigation>
 */
var TabNavigation = function TabNavigation(props) {
  var _applyCommonProps = applyCommonProps(props, TabNavigation),
    children = _applyCommonProps.children,
    className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  return /*#__PURE__*/React.createElement("nav", _extends({
    className: classNames(styles.tabNavigation, className)
  }, rest), /*#__PURE__*/React.createElement("ul", {
    className: styles.list
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: styles.tabNavigationItemContainer,
      key: index
    }, child);
  })));
};
TabNavigation.displayName = 'TabNavigation';

export { TabNavigation };
